import axios from 'axios'

const state = {
    unfilteredItems: null
}

const getters = {
    unfilteredItems (state) {
        return state.unfilteredItems
    },
    // console.log(Object.assign({}, activeUser))
}

const actions = {  
    async clearFilterAction({ commit, getters }) { 
        if(getters.itemsOnDisplay && getters.unfilteredItems) {
            commit('ITEMS_ON_DISPLAY', null)
            commit('ITEMS_ON_DISPLAY', getters.unfilteredItems)
            commit('UNFILTERED_ITEMS', null)
        }
    },
    
    async itemsBeforeFilterAction({ commit, getters }) { 
        if(getters.itemsOnDisplay && !getters.unfilteredItems) {
            commit('UNFILTERED_ITEMS', getters.itemsOnDisplay)
        }
    },

    async filterByNewestAction({ commit, getters }) { 
        if(!getters.itemsOnDisplay) return

        // store original itemsArr before applying filters
        // dispatch('itemsBeforeFilterAction')

        // sort the items arr results by newest using .rawDate property desc
        let currentItemsArr = getters.itemsOnDisplay
        function byNewest(a, b) {
            var counterA = a.rawDate;
            var counterB = b.rawDate;

            let comparison = 0;
            if (counterA < counterB) {
                comparison = 1;
            } else if (counterA > counterB) {
                comparison = -1;
            }
            return comparison;
        }

        let sortedItemsArr = currentItemsArr.sort(byNewest)
        return commit('ITEMS_ON_DISPLAY', sortedItemsArr)
    },
    
    async filterByRelevanceAction({ commit, getters }) { 
        if(!getters.itemsOnDisplay) return

        // store original itemsArr before applying filters
        // dispatch('itemsBeforeFilterAction')

        // sort the items arr results by relevance using .relevance property desc
        let currentItemsArr = getters.itemsOnDisplay
        function byRelevance(a, b) {
            var counterA = a.relevance;
            var counterB = b.relevance;

            let comparison = 0;
            if (counterA < counterB) {
                comparison = 1;
            } else if (counterA > counterB) {
                comparison = -1;
            }
            return comparison;
        }
        
        let sortedItemsArr = currentItemsArr.sort(byRelevance)
        return commit('ITEMS_ON_DISPLAY', sortedItemsArr)
    },
    
    async filterByExpensiveAction({ commit, getters }) { 
        if(!getters.itemsOnDisplay) return
        
        // store original itemsArr before applying filters
        // dispatch('itemsBeforeFilterAction')

        // sort the items arr results by expensive using .price property desc
        let currentItemsArr = getters.itemsOnDisplay
        function byExpensive(a, b) {
            var counterA = a.price;
            var counterB = b.price;

            let comparison = 0;
            if (counterA < counterB) {
                comparison = 1;
            } else if (counterA > counterB) {
                comparison = -1;
            }
            return comparison;
        }
        
        let sortedItemsArr = currentItemsArr.sort(byExpensive)
        return commit('ITEMS_ON_DISPLAY', sortedItemsArr)
    },
    
    async filterByAffordableAction({ commit, getters }) { 
        if(!getters.itemsOnDisplay) return

        // sort the items arr results by affordable using .price property asc
        let currentItemsArr = getters.itemsOnDisplay
        function byAffordable(a, b) {
            var counterA = a.price;
            var counterB = b.price;

            let comparison = 0;
            if (counterA > counterB) {
                comparison = 1;
            } else if (counterA < counterB) {
                comparison = -1;
            }
            return comparison;
        }
        
        let sortedItemsArr = currentItemsArr.sort(byAffordable)
        return commit('ITEMS_ON_DISPLAY', sortedItemsArr)
    },
    
    async filterByPriceAction({ dispatch, commit, getters }, priceObj) { 
        if(!getters.itemsOnDisplay) return
        
        // store original itemsArr before applying filters
        dispatch('itemsBeforeFilterAction')

        // sort the items arr results by price range using .price property and users margin input
        let currentItemsArr = getters.itemsOnDisplay

        // determine the arr filter to use based on the users input
        let sortedItemsArr = []
        if(priceObj.min && priceObj.max) {
            sortedItemsArr = currentItemsArr.filter(item => item.price >= priceObj.min && item.price <= priceObj.max)
        }
        if(priceObj.min && !priceObj.max) {
            sortedItemsArr = currentItemsArr.filter(item => item.price >= priceObj.min)
        }
        if(!priceObj.min && priceObj.max) {
            sortedItemsArr = currentItemsArr.filter(item => item.price <= priceObj.max)
        }
        return commit('ITEMS_ON_DISPLAY', sortedItemsArr)
    },
    
    async filterByConditionAction({ dispatch, commit, getters }, conditionObj) { 
        if(!getters.itemsOnDisplay) return
        
        // store original itemsArr before applying filters
        dispatch('itemsBeforeFilterAction')

        // sort the items arr results by condition using .condition property and users input
        let currentItemsArr = getters.itemsOnDisplay
        let sortedItemsArr = currentItemsArr.filter(item => item.condition == conditionObj.condition)
        return commit('ITEMS_ON_DISPLAY', sortedItemsArr)
    },
    
    async filterByCategoryAction({ dispatch, commit, getters }, categoryObj) { 
        if(!getters.itemsOnDisplay) return
        
        // store original itemsArr before applying filters
        dispatch('itemsBeforeFilterAction')

        // sort the items arr results by category using .category property and users input
        let currentItemsArr = getters.itemsOnDisplay
        let sortedItemsArr = currentItemsArr.filter(item => item.category == categoryObj.category)
        return commit('ITEMS_ON_DISPLAY', sortedItemsArr)
    },
}

const mutations = {
    UNFILTERED_ITEMS: (state, unfilteredItems) => (state.unfilteredItems = unfilteredItems),
}

export default {
    state,
    getters,
    actions,
    mutations
}